import React, { useState } from 'react';
import { useTranslation } from '../utils/i18n';
import './PDFViewer.css';

interface PDFViewerProps {
  isVisible: boolean;
  onClose: () => void;
  fileUrl: string;
  fileName: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ isVisible, onClose, fileUrl, fileName }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [loadPdfSec, setLoadPdfSec] = useState(false);

  const handleIframeLoad = () => {
    console.log('PDF loaded successfully');
    setLoading(false);
    setTimeout(() => {
      setLoadPdfSec(true);
    }, 100);
  };

  if (!isVisible) return null;

  const encodedUrl = encodeURIComponent(fileUrl);
  const viewerUrl = `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true&chrome=false&dov=1`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="pdf-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-viewer-header">
          <h3>{t('pdfViewer.previewFile') || 'Preview File'}</h3>
          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className={loadPdfSec ? "pdf-viewer-body btn-hide " : "pdf-viewer-body "}>
          {loading && (
            <div className="pdf-loading">
              <div className="loading-spinner"></div>
              <p>{t('pdfViewer.loadingPDF') || 'Loading PDF...'}</p>
            </div>
          )}
          <iframe
            src={viewerUrl}
            className="pdf-viewer-iframe"
            title="PDF Viewer"
            frameBorder="0"
            onLoad={handleIframeLoad}
            style={{ display: loading ? 'none' : 'block' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
